import React, { ReactNode, createContext, useContext } from "react";
import { useComplexState } from "use-complex-state";
import { PartComponentTypeReducer } from "../reducers/PartComponentTypeReducer";

const PartComponentTypeContext = createContext({
	state: PartComponentTypeReducer.getInitialState(),
	actions: PartComponentTypeReducer.actions,
});

export const usePartComponentTypeContext = () =>
	useContext(PartComponentTypeContext);

export const PartComponentTypeProvider = ({
	children,
}: { children: ReactNode }) => {
	const [state, actions] = useComplexState({
		initialState: PartComponentTypeReducer.getInitialState(),
		reducers: PartComponentTypeReducer.caseReducers,
	});

	return (
		<PartComponentTypeContext.Provider value={{ state, actions }}>
			{children}
		</PartComponentTypeContext.Provider>
	);
};
